import {activityPlaces} from '@mep/pae-commons';
import {Tag} from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

import {ACTIVITY_PLACE_LINK_TYPE_APPEARANCE} from '@/modules/activityPlace/contants/activityPlace.status';

const {ACTIVITY_PLACE_LINK_TYPES_ENUM} = activityPlaces;

const ActivityPlaceLinkType = ({type, full, className, icon, translationKey, ...props}) => {
  const {t} = useTranslation('activityPlace');
  
  if (!type || !ACTIVITY_PLACE_LINK_TYPE_APPEARANCE[type]) return (
    <Tag key={type} className={classNames({'w-full': full}, {'mx-auto': !full}, className, 'w-16 text-center')}>
      -
    </Tag>);
  
  return (<Tag
    color={ACTIVITY_PLACE_LINK_TYPE_APPEARANCE[type].color} key={type}
    className={classNames('table-tag-item', {'w-full': full}, {'mx-auto': !full}, 'max-w-44 flex justify-center', className)} {...props}>
    <div className={'flex items-center truncate'}>
      {icon}
      <span className={'flex-grow uppercase truncate'}>{t(`${translationKey}.${type}`)}</span>
    </div>
  </Tag>);
};

ActivityPlaceLinkType.propTypes = {
  className: PropTypes.string,
  translationKey: PropTypes.string,
  full: PropTypes.bool,
  type: PropTypes.oneOf(ACTIVITY_PLACE_LINK_TYPES_ENUM),
  icon: PropTypes.any,
};

ActivityPlaceLinkType.defaultProps = {
  translationKey: 'linkType'
};

export default memo(ActivityPlaceLinkType);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Status component in a table cell
 * @param {String} type this is the value of the dataIndex of the table (we will ignored in this case)
 * */
export const renderActivityPlaceLinkType = (type) => {
  return (<ActivityPlaceLinkType type={type}/>);
};
